import { render, staticRenderFns } from "./DepartmentAssignStaff.vue?vue&type=template&id=64573ff4&scoped=true"
import script from "./DepartmentAssignStaff.vue?vue&type=script&lang=js"
export * from "./DepartmentAssignStaff.vue?vue&type=script&lang=js"
import style0 from "./DepartmentAssignStaff.vue?vue&type=style&index=0&id=64573ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64573ff4",
  null
  
)

export default component.exports